module.exports = __webpack_public_path__ + "static-appopensalud/img/opensaludmx_healthierlives_color.3b41236.png";


//////////////////
// WEBPACK FOOTER
// ./static-appopensalud/img/logos/opensaludmx_healthierlives_color.png
// module id = 445
// module chunks = 116